import { FHIR_CANONICAL_BASE } from "@repo/fhir-systems";
import { z } from "zod";

export const newEntityIdSchema = z
  .string()
  .regex(/^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i, "Expected a UUIDv7 identity");

export const newCanonicalSchema = z
  .string()
  .url()
  .refine((value) => {
    if (!value.startsWith(`${FHIR_CANONICAL_BASE}/`)) return false;
    const segment = value.slice(value.lastIndexOf("/") + 1);
    return z.string().uuid().safeParse(segment).success;
  }, "Expected an application canonical ending in a UUID");
